(function () {
  function selectedVariant(options, value) {
    if (!value) return null;
    return Array.from(options).find(function (option) {
      return option.value === String(value) && !option.disabled;
    }) || null;
  }

  function resolveVariant(variants, values) {
    if (!values.length || values.some(value => !value)) return null;
    return variants.find(variant => variant.values.length === values.length && variant.values.every((value, index) => value === values[index])) || null;
  }

  function mediaSelection(groups, variants, selected) {
    const colourGroup = groups.find(group => group.kind === 'colour');
    const colour = colourGroup ? colourGroup.value : '';
    if (!colour) return { colour: '', imageId: '', variantId: selected ? selected.value : '' };
    const imageIds = variants
      .filter(variant => variant.values[colourGroup.position] === colour && variant.imageId)
      .map(variant => String(variant.imageId))
      .filter((value, index, values) => values.indexOf(value) === index);
    return {
      colour: colour,
      imageId: selected && selected.imageId ? String(selected.imageId) : (imageIds.length === 1 ? imageIds[0] : ''),
      variantId: selected ? String(selected.value) : ''
    };
  }

  if (typeof module !== 'undefined') module.exports = { mediaSelection: mediaSelection, selectedVariant: selectedVariant, resolveVariant: resolveVariant };
  if (typeof customElements === 'undefined' || customElements.get('menasa-purchase')) return;

  customElements.define('menasa-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.select = this.querySelector('[data-variant-select]');
      this.form = this.querySelector('form');
      if (!this.select || !this.form) return;
      this.groups = Array.from(this.querySelectorAll('[data-option-group]'));
      this.variants = Array.from(this.select.options).filter(option => option.value).map(option => ({ option, values: JSON.parse(option.dataset.options), imageId: option.dataset.imageId || '' }));
      this.submit = this.querySelector('[type="submit"]');
      this.groups.forEach(group => { group.hidden = false; group.disabled = false; });
      this.querySelector('[data-variant-fallback]').hidden = true;
      this.select.required = false;
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-group] input')) this.choose();
      }, { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-size-guide]');
        if (button) document.getElementById(button.dataset.sizeGuide)?.showModal();
      }, { signal: this.abort.signal });
      this.select.addEventListener('change', () => this.update(), { signal: this.abort.signal });
      this.form.addEventListener('submit', (event) => {
        if (!selectedVariant(this.select.options, this.select.value)) {
          event.preventDefault();
          this.querySelector('[data-purchase-error]').hidden = false;
          this.groups.find(group => !group.querySelector('input:checked'))?.querySelector('input')?.focus();
        }
      }, { signal: this.abort.signal });
      this.choose();
    }

    choose() {
      const values = this.groups.map(group => group.querySelector('input:checked')?.value || '');
      const variant = this.groups.length ? resolveVariant(this.variants, values) : this.variants[0];
      this.select.value = variant && !variant.option.disabled ? variant.option.value : '';
      // Keep impossible combinations visible and selectable so shoppers can change
      // either option without the picker trapping them in the previous choice.
      this.groups.forEach((group, index) => group.querySelectorAll('input').forEach(input => {
        const candidate = values.map((value, position) => position === index ? input.value : value);
        const available = this.variants.some(v => !v.option.disabled && v.values.every((value, position) => !candidate[position] || candidate[position] === value));
        input.nextElementSibling.classList.toggle('is-unavailable', !available);
      }));
      const complete = values.every(Boolean);
      const unavailable = complete && (!variant || variant.option.disabled);
      this.submit.disabled = unavailable;
      this.submit.textContent = unavailable ? this.dataset.unavailableLabel : this.dataset.addLabel;
      this.querySelector('[data-purchase-error]').hidden = !unavailable;
      this.update();
    }

    update() {
      const option = selectedVariant(this.select.options, this.select.value);
      const root = this.closest('.menasa-product-page-root');
      if (!root) return;
      const groupState = this.groups.map(group => ({
        kind: group.dataset.optionKind || '',
        position: Number(group.dataset.position),
        value: group.querySelector('input:checked')?.value || ''
      }));
      const variantState = this.variants.map(variant => ({
        values: variant.values,
        imageId: variant.imageId
      }));
      const selectedState = option ? { value: option.value, imageId: option.dataset.imageId || '' } : null;
      this.dispatchEvent(new CustomEvent('menasa:media', { bubbles: true, detail: mediaSelection(groupState, variantState, selectedState) }));
      if (!option) return;
      const price = root.querySelector('[data-live-price]');
      const compare = root.querySelector('[data-live-compare]');
      const sku = root.querySelector('[data-live-sku]');
      if (price) price.textContent = option.dataset.price;
      if (compare) {
        compare.textContent = option.dataset.compare;
        compare.classList.toggle('hidden', !option.dataset.compare);
      }
      if (sku) {
        sku.textContent = option.dataset.sku;
        sku.parentElement.classList.toggle('hidden', !option.dataset.sku);
      }
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      this.abort = null;
      this.groups?.forEach(group => { group.hidden = true; group.disabled = true; });
      const fallback = this.querySelector('[data-variant-fallback]');
      if (fallback) fallback.hidden = false;
    }
  });
}());
